/**
 * DashboardPage Component
 * Main dashboard with welcome content and recent requests
 */

import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { DashboardHeader } from '@/components/layout/DashboardHeader';
import { Footer } from '@/components/layout/Footer';
import { WelcomeSection } from '@/components/dashboard/WelcomeSection';
import { RecentRequests } from '@/components/dashboard/RecentRequests';

/**
 * Dashboard page - always shows welcome content and recent requests
 */
export default function DashboardPage() {
  return (
    <DashboardLayout
      header={<DashboardHeader />}
      footer={<Footer />}
      className="overflow-hidden"
    >
      {/* Welcome section with hero and carousel */}
      <WelcomeSection />

      {/* Recent requests section */}
      <RecentRequests />
    </DashboardLayout>
  );
}
